import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useInquiryForm from './hooks/useInquiryForm';

type UseInquiryForm = ReturnType<typeof useInquiryForm>;

interface Props {
    reset: UseInquiryForm['reset'];
    handleCreateInquiry: UseInquiryForm['handleCreateInquiry'];
}

function InquiryFormFooter({ reset, handleCreateInquiry }:Props) {
    const { t } = useTranslation('inquiry');
    return (
        <Container spacing={8} fullWidth>
            <Button variant='secondary'
                onClick={reset}
                fullWidth
                noPadding
                type='button'>{t('form.reset')}</Button>
            <Button fullWidth
                noPadding
                onClick={handleCreateInquiry} >
                {t('form.submit')}
            </Button>
        </Container>
    );
}

const Container = styled(Row)`
    background-color: var(--color-white);
    border-top: 2px solid var(--color-gray2);
    bottom: 0;
    padding: 20px;
    position: sticky;
`;

export default InquiryFormFooter;
